<div class="layout-topbar">
  <!-- <div class="topbar-start">
    <button #menubutton type="button" class="topbar-menubutton p-link p-trigger transition-duration-300"
      (click)="onMenuButtonClick()">
      <i class="pi pi-bars"></i>
    </button>
  </div>
  <div class="layout-topbar-menu-section">
    <app-sidebar></app-sidebar>
  </div> -->
  <div class="topbar-end">
    <ul class="topbar-menu">
      <li class="topbar-item">
        <div
          class="flex align-items-center"
          pStyleClass="@next"
          enterFromClass="ng-hidden"
          enterActiveClass="px-scalein"
          leaveToClass="ng-hidden"
          leaveActiveClass="px-fadeout"
          [hideOnOutsideClick]="true"
          pRipple
          (click)="onSidebarButtonClick()"
        >
          <span>
            <img src="assets/images/logos/logo-user.png" />
          </span>
          <div class="ml-3 hidden  sm:block">
            <div class="text-900 text-xl font-medium mb-1">
              {{ this.storageService.getUser().fullName }}
            </div>
            <div class="text-600">
              {{ this.storageService.getUser().roleName }}
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</div>
